import { createElement } from "react";
import { createRouter, type RouterHistory } from "@tanstack/react-router";
import { QueryClient } from "@tanstack/react-query";
import NotFoundPage from "./components/shell/NotFoundPage";
import { PendingPage } from "./components/ui/Skeleton";
import { routeTree } from "./routeTree.gen";

// Route-level pending UI (issue 32): any route whose loader or code-split
// chunk takes longer than `defaultPendingMs` renders the shared skeleton page
// instead of nothing; once shown it stays for `defaultPendingMinMs` so a fast
// resolve does not flicker.
function DefaultPending() {
  return createElement(PendingPage, { label: "Loading" });
}

// An address the app does not have shows a page that says so with a way back,
// not the router's bare "Not Found". Inside a Company the Company's default
// page opens instead (see routes/_authenticated/$orgSlug.tsx).

/** `history` is for tests; the app uses the browser's. */
export function makeRouter(queryClient: QueryClient, history?: RouterHistory) {
  return createRouter({
    routeTree,
    history,
    context: { queryClient },
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    defaultPendingComponent: DefaultPending,
    defaultPendingMs: 200,
    defaultPendingMinMs: 300,
    defaultNotFoundComponent: NotFoundPage,
    scrollRestoration: true,
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof makeRouter>;
  }
}
